import { useState } from "react"
import GetAllBiomarkersByPatientId from "../../data_layer/repositories/Biomarkers/GetAllBiomarkersByPatient";
import CalculateCustomBiomarkers from "../../data_layer/repositories/Biomarkers/CalculateCostumBiomarkers";
import { BiomarkersCard } from "../Cards/BiomarkersCard";


/**
 * 
 * @param {*} feedings      List of feeding timestamps to generate biomarkers [1763751470, 1763754870, ...]
 * @param {*} patient_id    Patient ID
 * @param {*} options       Biomarker generation options
 * @returns List of generated biomarkers
 */
export const useCustomBiomarkers = (feedings, patient_id, options) => {
    const [biomarkers, setBiomarkers] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const generateBiomarkers = async (selectedFeedings) => {

        setIsLoading(true);

        const biomarkers = await CalculateCustomBiomarkers(patient_id, feedings, options);
        setBiomarkers(biomarkers);
        setIsLoading(false);
    }

    return {
        biomarkers,
        isLoading,
        generateBiomarkers,
    };

}
